import { ReactNode } from "react";

import "./FormHeader.scss";

export interface FormHeaderProps {
  title: string;
  badge?: ReactNode; // Badge is not ready yet
  description?: string;
  button?: ReactNode;
  isAlert?: boolean;
}

function FormHeader({ title, description, button, badge, isAlert }: FormHeaderProps) {
  return (
    <div className={`form-header ${isAlert ? "packing-list-header" : ""}`}>
      <div className="header-left">
        <div className="d-flex align-items-center">
          <div className="text-lg title">{title}</div>
          <div className="ml-md">{badge}</div>
        </div>
        <div className="text-tertiary text-sm">{description}</div>
      </div>
      <div className="header-right">{button && button}</div>
    </div>
  );
}

FormHeader.defaultProps = {
  badge: null,
  description: "",
  button: null,
  isAlert: false,
};

export default FormHeader;
